import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import { BIRTHDAY_PROMOTION_REGULATIONS_LINK } from 'constants/links'
import { Wrapper } from './styles'

const BirthdayPromotionInfo = () => (
    <Wrapper
        variant="bodySmall"
        color="grayscale_400"
        mb={0}
        id="cabana-promo-info"
    >
        <FormattedMessage
            id="promo.birthday.cabana_promo_info"
            defaultMessage="Z kodem <span>URODZINY</span> kupisz Cabanę <span>50% taniej</span>! <break></break><strong>Zniżka naliczy się po wpisaniu kodu rabatowego w podsumowaniu zamówienia.</strong> <break></break> Promocja obowiązuje do 29 lutego 2024 lub do wyczerpania zapasów. "
            description="Keep the html tags in the translation"
            values={{
                span: (chunks: string[]) => (
                    <>
                        <Text as="span" variant="bodySmall" color="primary_500">
                            {chunks}
                        </Text>
                    </>
                ),
                strong: (chunks: string[]) => (
                    <>
                        <Text
                            as="strong"
                            variant="bodySmallStrong"
                            color="grayscale_400"
                        >
                            {chunks}
                        </Text>
                    </>
                ),
                break: (chunks: string[]) => <br />,
            }}
        />
        <Text
            as="a"
            href={BIRTHDAY_PROMOTION_REGULATIONS_LINK}
            target="_blank"
            variant="bodySmall"
            isUnderlined
            color="grayscale_400"
        >
            <FormattedMessage
                id="promo.black_weekend.regulations_link"
                defaultMessage="Regulamin promocji"
            />
        </Text>
    </Wrapper>
)

export default BirthdayPromotionInfo
